export default __webpack_public_path__ + "static/media/oneTomoea.800090ba.png";